import Backbone from 'backbone';
import ReactDOM from 'react-dom';
import React from 'react';
import { PanelBackboneWrapper } from './panel-backbone-wrapper';

const defaultPanelProps = {
  onClose: () => {},
  isOpen: false,
};

export const panelDecorator = (View, panelOptions) => {
  const DecoratedPanelView = Backbone.View.extend({
    initialize(options) {
      this.panelProps = {
        ...defaultPanelProps,
        ...panelOptions,
        title: options.title,
        onClose: options.onClose,
      };

      this.options = options;
      this.eventsToActions = options.eventsToActions;
    },

    render() {
      this.panelProps = {
        ...this.panelProps,
        isOpen: true,
      };

      ReactDOM.render(
        (
          <PanelBackboneWrapper
            panelProps={this.panelProps}
            View={View}
            viewOptions={this.options}
            eventsToActions={this.eventsToActions}
          />
        ),
        this.el
      );

      return this;
    },

    remove() {
      ReactDOM.unmountComponentAtNode(this.el);
      Backbone.View.prototype.remove.call(this);
    },
  });

  return DecoratedPanelView;
};
